/* eslint-disable @typescript-eslint/naming-convention */

import { Attachment } from '@app/components/attachments/attachment'
import { Staff } from '@app/components/hr/staff/staff'
import { AssetAllocationPremises } from '@app/components/logistics/assets-allocations-premises/assets-allocations-premises'
import { AssetAllocationUsage } from '@app/components/logistics/assets-allocations-usages/assets-allocations-usages'
import { newWorkflowState, WorkflowState, WorkflowTransition } from '@app/components/workflows/workflows'

import { ConfirmationMethod, ConfirmationState, ConfirmationTransition, ConfirmationType } from './confirmations.constants'

export interface ConfirmationStaffRelation {
  confirming_staff: Staff
  notify_user: boolean
}

export interface ConfirmationWorkflowPayload {
  code?: string
  method?: ConfirmationMethod
  type?: string
}

export interface Confirmation {
  id?: number
  code?: string
  type?: ConfirmationType
  confirmation_staff_relations?: ConfirmationStaffRelation[]
  allowed_methods: ConfirmationMethod[]
  date_confirmed?: string
  rejection_reason?: string
  content?: AssetAllocationUsage | AssetAllocationPremises

  state: WorkflowState<ConfirmationState>
  workflow: string
  transitions: WorkflowTransition<ConfirmationState, ConfirmationTransition>[]
}

export interface ConfirmationWithAttachments extends Confirmation {
  attachments: Attachment[]
}

export function newConfirmation (data?: Partial<Confirmation>): Confirmation {
  return {
    allowed_methods: [],
    state: newWorkflowState(),
    transitions: [],
    workflow: 'confirmations-workflow',
    ...data,
  }
}
